class productRecommendations extends HTMLElement {
  constructor() {
    super();

    this.observer = null;
  }

  get recommendationsUrl() {
    return this.dataset.url;
  }

  connectedCallback() {
    this.observer = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) return;

      fetch(this.recommendationsUrl)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    {
      rootMargin: "0px 0px 200px 0px"
    }
    )

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('product-recommendations', productRecommendations);
